import { render, staticRenderFns } from "./totalSearchChild.vue?vue&type=template&id=c1a3e27e&scoped=true&"
import script from "./totalSearchChild.vue?vue&type=script&lang=js&"
export * from "./totalSearchChild.vue?vue&type=script&lang=js&"
import style0 from "./totalSearchChild.vue?vue&type=style&index=0&id=c1a3e27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a3e27e",
  null
  
)

export default component.exports